import {initCore} from 'src/lib/init.js'
import Vue from 'vue'
import rootComponent from '@/root/sddf.js'
initCore()
new Vue(rootComponent)